<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <!-- rederizando componente alert -->
                <alert></alert>
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>{{ boxTitle }}</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Unidade</label>
                                    <input v-model="dados.nome" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Tipo de Unidade</label>
                                    <select v-model="dados.unidade_tipo_id" class="form-control">
                                        <option value>-- Selecione --</option>
                                        <option v-for="item in tiposUnidade" :key="item.id" :value="item.id">{{ item.nome }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Categoria</label>
                                    <select v-model="dados.categoria" class="form-control">
                                        <option value="0">Pública (Local)</option>
                                        <option value="1">Município Pactuado</option>
                                        <option value="2">Privada</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>CNPJ</label>
                                    <input v-mask="'##.###.###/####-##'" v-model="dados.cnpj" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>CNES</label>
                                    <input v-model="dados.cnes" class="form-control" type="number" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Telefone</label>
                                    <input v-mask="['(##)#####-####', '(##)####-####']" v-model="dados.telefone" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Situação</label>
                                    <select v-model="dados.situacao" class="form-control">
                                        <option value="1">Ativo</option>
                                        <option value="0">Inativo</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>CEP</label>
                                    <input v-mask="['#####-###']" v-model="dados.cep" class="form-control" type="text" @blur="getEndereco()" ref="cep" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Endereço</label>
                                    <input v-model="dados.endereco" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Número</label>
                                    <input v-model="dados.numero_endereco" class="form-control" type="text" ref="numero_endereco" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Bairro</label>
                                    <input v-model="dados.bairro" class="form-control" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Complemento</label>
                                    <input v-model="dados.complemento_endereco" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Ponto de referência</label>
                                    <input v-model="dados.ponto_referencia" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Cidade</label>
                                    <input :disabled="true" v-model="dados.cidade" class="form-control" type="text" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>UF</label>
                                    <input :disabled="true" v-model="dados.uf" class="form-control" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12" :class="{ 'has-error': showTextDangerTipo }">
                                <div class="form-group">
                                    <label :class="{ 'erro-validacao': showTextDangerTipo }">Permite agendamentos para pacientes de outros municípios?</label>
                                    <select v-model="dados.paciente_outro_municipio" class="form-control">
                                        <option value>--Selecione--</option>
                                        <option value="1">SIM</option>
                                        <option value="0">NÃO</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Anotações</label>
                                    <textarea v-model="dados.anotacoes" class="form-control" rows="7"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-footer">
                        <div class="row">
                            <div class="col-md-12">
                                <button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
                                <button class="btn btn-default pull-left" @click="$router.go(-1)"><i class="fa fa-reply"></i> Voltar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import Alert from "../../Alert"; // Importando componente alert
import selectUnidade from "../../cadastros/unidades/selectUnidade";
import { mask } from "vue-the-mask";

export default {
    directives: {
        mask
    },
    filters: {},
    data: () => ({
        dados: {
            nome: "",
            unidade_tipo_id: "",
            categoria: 0,
            cnpj: "",
            cnes: "",
            telefone: "",
            situacao: 1,
            cep: "",
            endereco: "",
            numero_endereco: "",
            bairro: "",
            complemento_endereco: "",
            cidade: "",
            uf: "",
            ponto_referencia: "",
            paciente_outro_municipio: 0,
            anotacoes: ""
        },
        tiposUnidade: [],
        unidadeId: "",
        boxTitle: "Nova Unidade"
    }),
    mounted() {
        this.unidadeId = this.$route.params.unidade_id;
        if (this.unidadeId) {
            this.boxTitle = "Editar Unidade";
            this.getUnidade(this.unidadeId);
        }
        this.getTiposUnidade();
    },
    methods: {
        getEndereco() {
            if (this.dados.cep && this.dados.cep != "") {
                this.$store.commit("TOGGLE_LOADING");
                axios
                    .get(`https://viacep.com.br/ws/${this.dados.cep}/json/`)
                    .then(response => {
                        console.log(response.data);
                        if (response.data.erro) {
                            this.$swal({
                                type: "warning",
                                title: "Digite um CEP válido!",
                                text: ""
                            }).then(() => {
                                this.dados.cep = "";
                                this.dados.endereco = "";
                                this.dados.bairro = "";
                                this.dados.cidade = "";
                                this.dados.uf = "";
                                this.$refs.cep.focus();
                            });
                            return false;
                        }

                        this.dados.endereco = response.data.logradouro;
                        this.dados.bairro = response.data.bairro;
                        this.dados.cidade = response.data.localidade;
                        this.dados.uf = response.data.uf;
                        this.$store.commit("TOGGLE_LOADING");

                        this.$refs.numero_endereco.focus();
                    })
                    .catch(() => {
                        this.$swal({
                            type: "warning",
                            title: "Não conseguimos buscar seu endereço!",
                            text: "Por favor, digite um CEP válido!"
                        });
                    });
            }
        },
        getUnidade(unidadeId) {
            axios.get(`${this.$store.state.serverURI}/api/cadastros/unidades/getById/${this.unidadeId}`, this.$store.getters.getHeaderAuth).then(response => {
                let dados = response.data;
                dados.uf = response.data.cidade.uf.uf;
                dados.cidade = response.data.cidade.nome;
                this.dados = dados;
            });
        },
        getTiposUnidade() {
            axios.get(`${this.$store.state.serverURI}/api/cadastros/tipos-unidade/getAll`, this.$store.getters.getHeaderAuth).then(response => {
                this.tiposUnidade = response.data;
            });
        },
        salvar() {
            if (this.unidadeId) {
                axios
                    .post(`${this.$store.state.serverURI}/api/cadastros/unidades/update/${this.unidadeId}`, this.dados, this.$store.getters.getHeaderAuth)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Unidade atualizada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.$router.push("/cadastros/unidades/");
                    })
                    .catch(error => {
                        var erros = error.response.data.message + " ";
                        for (var erro of Object.values(error.response.data.errors)) {
                            erros += erro + " \n";
                        }
                        this.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
            } else {
                axios
                    .post(`${this.$store.state.serverURI}/api/cadastros/unidades/create`, this.dados, this.$store.getters.getHeaderAuth)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Unidade criada com sucesso!",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.$router.push("/cadastros/unidades/");
                    })
                    .catch(error => {
                        var erros = error.response.data.message + " ";
                        for (var erro of Object.values(error.response.data.errors)) {
                            erros += erro + " \n";
                        }
                        this.$swal({
                            type: "error",
                            title: "Houve uma falha!",
                            text: erros
                        });
                    });
            }
        }
    },
    watch: {},
    components: {
        Alert,
        selectUnidade
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// form.vue?54a19284